function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/helpers/interopRequireDefault.js
// module id = 0
// module chunks = 1 2